import type {DomainEntity, DTOEntity } from "@akina/domain";


export type DomainMapper<TDomain extends DomainEntity, TDTO extends DTOEntity> = {
  toDomain: (dto: TDTO) => TDomain;
}
export type Mapper<TDomain extends DomainEntity, TDTO extends DTOEntity> = {
  toDTO: (domain: TDomain) => TDTO;
} & DomainMapper<TDomain, TDTO>
export const mapDateFromApi = (date: string): Date => (date.endsWith("Z") ? new Date(date) : new Date(`${date}Z`));

export const mapNullableDateFromApi = (date: string | null): Date | null => {
  if (date) return date.endsWith("Z") ? new Date(date) : new Date(`${date}Z`);
  return null;
}

export * from "./clinicMapper";
export * from "./onboardingMapper";
export * from "./patientMapper";
export * from "./sessionReviewMapper";
export * from "./templateMapper";
export * from "./therapySessionMapper";
export * from "./treatmentMapper";
